<script setup lang="ts">
import { useVehicleStore } from '../../stores/vehicleStore'

const vehicleStore = useVehicleStore()

function onChange(e: Event) {
  const val = Number((e.target as HTMLSelectElement).value)
  if (val > 0) {
    vehicleStore.selectBodyType(val)
  }
}
</script>

<template>
  <div v-if="vehicleStore.showBodyTypeSelector" class="body-type-selector">
    <label class="body-type-selector__label">Velg karosseritype</label>
    <div class="body-type-selector__dropdown">
      <select @change="onChange">
        <option :value="0">Velg karosseri</option>
        <option
          v-for="bt in vehicleStore.bodyTypes"
          :key="bt.qualColId"
          :value="bt.qualColId"
        >
          {{ bt.qualColText }}
        </option>
      </select>
    </div>
  </div>
</template>

<style scoped lang="scss">
.body-type-selector {
  margin-bottom: 1rem;
  max-width: 400px;

  &__label {
    display: block;
    font-weight: 600;
    margin-bottom: 0.4rem;
  }

  &__dropdown select {
    width: 100%;
    padding: 10px 12px;
    border: 2px solid #002868;
    border-radius: 6px;
    font-size: 0.95rem;
    appearance: none;
    background: white url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%23002868' stroke-width='2'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E") no-repeat right 10px center;
    cursor: pointer;

    &:focus {
      outline: none;
      box-shadow: 0 0 0 2px rgba(0, 40, 104, 0.2);
    }
  }
}
</style>
